import React from 'react'
import MapContainer from '../Map/MapContainer'
import MapMenuContainer from '../MapMenu/MapMenuContainer'
import MapMessageContainer from '../MapMessage/MapMessageContainer'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	map: {
		display: 'flex',
		position: 'relative',
		height: '100%',
		flex: 1.,
		flexDirection: 'column'
	},
	controls: {
		display: 'flex',
		position: 'absolute',
		zIndex: theme.zIndex.onTopOfMap,
		top: theme.spacing.unit * 3,
		left: theme.spacing.unit * 3,
	}
})

const WideMapArea = ({ classes }) => (	
    <div className={classes.map}>
		<Paper elevation={24} className={classes.controls}>
			<MapMenuContainer />
		</Paper>
		<MapMessageContainer />
		<MapContainer/>
    </div>
)
//
export default withStyles(styles)(WideMapArea)



// WEBPACK FOOTER //
// ./src/components/Layout/WideMapArea.js